import React, { Component } from 'react';
import { colors, elements } from '@peachjar/components';
import { css, cx } from 'react-emotion';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const { Paragraph } = elements.typography;
const { silver, slate } = colors;

const classNames = {
  accountIcon: css`
    font-size: 2rem;
    color: ${slate};
  `,
  accountImage: css`
    border-radius: 50%;
    max-height: 3rem;
  `,
  accountSection: css`
    height: 100%;
    padding-left: 1rem;
    border-left: 1px solid ${silver};
    cursor: pointer;
  `,
};

class AccountSection extends Component {
  state = {
    menuAnchorElement: null,
  };

  setMenuAnchor = event => {
    this.setState({ menuAnchorElement: event.currentTarget });
  };

  unsetMenuAnchor = () => {
    this.setState({ menuAnchorElement: null });
  };

  logout = () => {
    this.unsetMenuAnchor();
    this.props.logout();
  };

  toggleMenuAnchor = event =>
    this.state.menuAnchorElement
      ? this.unsetMenuAnchor()
      : this.setMenuAnchor(event);

  getProfileImage = () => {
    if (this.props.image) {
      return <img className={cx(classNames.accountImage, 'mr-2')} src={this.props.image} alt="Profile" />
    }
    return <span
      className={cx(classNames.accountIcon, 'material-icons', 'mr-2')}>
      account_circle
    </span>
  }

  render() {
    const { menuAnchorElement } = this.state;
    const { email } = this.props;

    return (
      <div
        className={cx(
          classNames.accountSection,
          'layout-row',
          'layout-align-end-center'
        )}
        aria-owns={menuAnchorElement ? 'account-menu' : null}
        aria-haspopup="true"
      >
        {this.getProfileImage()}

        <Paragraph>{email}</Paragraph>

        <span
          className={cx(classNames.accountIcon, 'material-icons', 'ml-2')}
          onClick={this.toggleMenuAnchor}
        >
          expand_more
        </span>

        <Menu
          id="account-menu"
          anchorEl={menuAnchorElement}
          open={Boolean(menuAnchorElement)}
          onClose={this.unsetMenuAnchor}
        >
          <MenuItem onClick={this.logout}>Log Out</MenuItem>
        </Menu>
      </div>
    );
  }
}

export default AccountSection;



// WEBPACK FOOTER //
// ./src/_app/components/BrandBar/components/AccountSection.jsx